window.LLCartAjax = (function () {
  if (window.__LLCartAjaxSharedSingleton) {
    return window.__LLCartAjaxSharedSingleton;
  }

  const state = {
    inflight: new Set()
  };

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';
  }

  async function fetchCart() {
    const res = await fetch(rootPath() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache'
      }
    });

    if (!res.ok) {
      throw new Error('cart.js fetch failed');
    }

    return res.json();
  }

  async function changeByKey(itemKey, quantity) {
    const res = await fetch(rootPath() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: Math.max(0, Number(quantity || 0))
      })
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error('cart/change.js failed: ' + text);
    }

    return res.json();
  }

  async function fetchSectionHtml(sectionId) {
    const id = String(sectionId || '').trim();

    if (!id) {
      throw new Error('section id missing');
    }

    const res = await fetch(rootPath() + `?sections=${encodeURIComponent(id)}&_=${Date.now()}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache'
      }
    });

    if (!res.ok) {
      throw new Error('section refresh failed');
    }

    const data = await res.json();

    if (!data || !data[id]) {
      throw new Error('invalid section response');
    }

    return data[id];
  }

  function parseHTML(html) {
    const wrap = document.createElement('div');
    wrap.innerHTML = String(html || '');
    return wrap;
  }

  function syncGlobalBubbleCount(cart) {
    if (!cart) return;

    const count = Number(cart.item_count || 0);

    document.querySelectorAll(
      '.cart-bubble__text, .cart-count, [data-cart-count], [data-cart-item-count], .cart-count-bubble, .cart-count-bubble span'
    ).forEach((el) => {
      if (!el) return;

      if (
        el.matches('.cart-count') &&
        el.closest('cart-drawer-component')
      ) {
        el.textContent = String(count);
        return;
      }

      el.textContent = String(count);
      el.setAttribute('data-cart-count', String(count));

      // The premium header always displays its cart counter, including 0.
      if (el.matches('.ll-cart-count[data-cart-count]')) {
        el.classList.remove('is-empty');
        el.removeAttribute('hidden');
      } else if (count <= 0) {
        el.classList.add('is-empty');
        el.setAttribute('hidden', '');
      } else {
        el.classList.remove('is-empty');
        el.removeAttribute('hidden');
      }
    });
  }

  function dispatchCartEvents(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart }
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart }
      })
    );
  }

  function dispatchCartRefresh(cart, open) {
    document.dispatchEvent(
      new CustomEvent(open ? 'cart:open' : 'cart:refresh', {
        bubbles: true,
        detail: {
          cart,
          open: !!open
        }
      })
    );
  }

  function lockKey(key) {
    state.inflight.add(String(key));
  }

  function unlockKey(key) {
    state.inflight.delete(String(key));
  }

  function isLocked(key) {
    return state.inflight.has(String(key));
  }

  function getDisplayedQuantity(itemKey) {
    if (!itemKey || typeof CSS === 'undefined' || !CSS.escape) return null;

    const display = document.querySelector(
      `.cart-drawer .inline-qty-form[data-item-key="${CSS.escape(itemKey)}"] .qty-inline-display`
    );

    if (!display) return null;

    const qty = parseInt(display.textContent || '', 10);

    return Number.isFinite(qty) ? qty : null;
  }

  async function updateQuantityFlow(options) {
    const {
      itemKey,
      delta = null,
      explicitQuantity = null,
      beforeRequest,
      afterSuccess,
      afterError,
      afterFinally
    } = options || {};

    if (!itemKey) return null;
    if (isLocked(itemKey)) return null;

    lockKey(itemKey);

    const display = typeof CSS !== 'undefined' && CSS.escape
      ? document.querySelector(
          `.cart-drawer .inline-qty-form[data-item-key="${CSS.escape(itemKey)}"] .qty-inline-display`
        )
      : null;

    const displayedQty = getDisplayedQuantity(itemKey);
    const currentQty = displayedQty !== null ? displayedQty : 1;

    let nextQty = explicitQuantity;

    if (nextQty === null || typeof nextQty === 'undefined') {
      nextQty = currentQty + Number(delta || 0);
    }

    nextQty = Math.max(0, Number(nextQty || 0));

    try {
      if (display) {
        display.textContent = String(nextQty);
      }

      if (typeof beforeRequest === 'function') {
        beforeRequest();
      }

      const updatedCart = await changeByKey(itemKey, nextQty);

      syncGlobalBubbleCount(updatedCart);
      dispatchCartEvents(updatedCart);

      if (typeof afterSuccess === 'function') {
        await afterSuccess(updatedCart);
      }

      return updatedCart;
    } catch (error) {
      if (display) {
        display.textContent = String(currentQty);
      }

      if (typeof afterError === 'function') {
        afterError(error);
      }

      throw error;
    } finally {
      unlockKey(itemKey);

      if (typeof afterFinally === 'function') {
        afterFinally();
      }
    }
  }

  window.__LLCartAjaxSharedSingleton = {
    rootPath,
    fetchCart,
    changeByKey,
    fetchSectionHtml,
    parseHTML,
    syncGlobalBubbleCount,
    dispatchCartEvents,
    dispatchCartRefresh,
    updateQuantityFlow,
    isLocked
  };

  return window.__LLCartAjaxSharedSingleton;
})();